import { FC, useCallback, useEffect } from "react";

import { Button, DatePicker, Form, Input, message, Select } from "antd";
import PopupOffer from "src/module/popupActivity/components/popupOffer";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import popupActivityService from "src/module/popupActivity/service";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";

export const PopupModify: FC = () => {
	const [formRef] = Form.useForm();
	const { Item: FormItem } = Form;
	const { t } = useTranslation();
	const navigate = useNavigate();
	const parseId = Number(useParams().id) || null;

	const init = useCallback(async () => {
		if (!parseId) return;
		const { data: res } = await popupActivityService.detail(parseId);
		if (res.code === 200) {
			const finalData = {
				...res.data,
				startAt: moment(res.data.startAt),
				expiredAt: moment(res.data.expiredAt),
				...(res.data.popupType === 1 && {
					couponsList: {
						couponList: res.data.couponList,
						subscriptionCouponList: res.data.subscriptionCouponList,
					},
				}),
				...(res.data.popupType === 2 && {
					subscriptionId: res.data.subscriptionId,
				}),
			};
			formRef.setFieldsValue(finalData);
		}
	}, [parseId, formRef]);

	useEffect(() => {
		init();
	}, [init]);

	const getSubs = (e: any) => {
		if (e.popupType === 1) {
			return [
				...(e?.couponsList?.couponList || []).map((item: any) => {
					return {
						couponId: item.id,
						amount: item.amount,
						...(item.parentId && { parentId: item.parentId }),
					};
				}),
				...(e?.couponsList?.subscriptionCouponList || []).map((item: any) => {
					return {
						subscriptionCouponId: item.id,
						amount: item.amount,
						...(item.parentId && { parentId: item.parentId }),
					};
				}),
			];
		} else if (e.popupType === 2) {
			return [
				{
					subscriptionId: e.subscriptionId,
					amount: 1,
				},
			];
		} else {
			return [];
		}
	};

	const submit = async (e: any) => {
		await formRef.validateFields();
		const finalVales = {
			...e,
			startAt: e.startAt?.format("YYYY-MM-DD 00:00:00"),
			expiredAt: e.expiredAt?.format("YYYY-MM-DD 23:59:59"),
			subs: getSubs(e),
			couponsList: void 0,
		};
		if (e.popupType && e.popupType !== 3 && !finalVales.subs.length) {
			message.error("请选择优惠券或会员卡");
			return;
		}
		let response: any = {};
		if (!parseId) {
			response = await popupActivityService.add(finalVales);
		} else {
			response = await popupActivityService.update(parseId!, finalVales);
		}
		if (response.data.code !== 200) {
			message.error(response.data.msg);
			return;
		}
		navigate("/activity/popup");
	};
	const userOptions = [
		{
			label: "会员卡客户",
			value: 1,
		},
		{
			label: "非会员卡客户",
			value: 2,
		},
	];

	return (
		<Container>
			<Form layout='vertical' labelAlign='left' labelCol={{ span: 4 }} onFinish={submit} form={formRef}>
				<FormItem label='客户类型' name='type' required>
					<Select options={userOptions} placeholder='请选择客户类型' />
				</FormItem>
				<FormItem label={t("startTime")} name='startAt'>
					<DatePicker />
				</FormItem>
				<FormItem label={t("endTime")} name='expiredAt'>
					<DatePicker />
				</FormItem>
				<FormItem label='Group' name='rfmGroup' required>
					<Select
						options={[1, 2, 3].map((num) => {
							return { label: num, value: num };
						})}
						placeholder='请选择Group'
					/>
				</FormItem>
				<FormItem label='Offer' name='offer' required>
					<Select
						options={[1, 2, 3].map((num) => {
							return { label: num, value: num };
						})}
						placeholder='请选择offer'
					/>
				</FormItem>
				{
					<FormItem dependencies={["offer"]}>
						{({ getFieldValue }) => {
							const offer = getFieldValue("offer");
							return (
								<FormItem label={`Offer${offer ? offer : ""}`} name='popupType' required>
									<PopupOffer />
								</FormItem>
							);
						}}
					</FormItem>
				}

				<FormItem className='lastSubmit'>
					<Button type='primary' htmlType='submit'>
						提交
					</Button>
				</FormItem>
			</Form>
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100%;

	box-sizing: border-box;
	padding: 30px;
	padding-right: 300px;
	.ant-picker {
		width: 100%;
	}
	.lastSubmit {
		display: flex;
		justify-content: flex-start;
		height: 150px;
	}
`;
